<template>
  <main class="login-page">
    <div class="login-shell">
      <!-- Panel visual / marca -->
      <aside class="login-brand-panel">
        <div class="brand-glow brand-glow--1"></div>
        <div class="brand-glow brand-glow--2"></div>

        <div class="brand-content">
          <div class="brand-logo-wrap">
            <img src="/assets/Logo.png" alt="MI STOCK" class="brand-logo">
          </div>

          <div class="carousel-frame">
            <transition name="fade" mode="out-in">
              <div :key="currentImage" class="carousel-slide">
                <img
                  :src="carouselImages[currentImage].src"
                  :alt="carouselImages[currentImage].alt"
                >
              </div>
            </transition>
          </div>

          <p class="brand-tagline">{{ carouselImages[currentImage].caption }}</p>

          <div class="carousel-indicators">
            <button
              v-for="(image, index) in carouselImages"
              :key="index"
              type="button"
              :aria-label="`Ir a imagen ${index + 1}`"
              :class="{ active: currentImage === index }"
              @click="currentImage = index"
            ></button>
          </div>
        </div>
      </aside>

      <!-- Panel formulario -->
      <section class="login-form-panel">
        <div class="form-wrapper">
          <img src="/assets/Logo.png" alt="MI STOCK" class="mobile-logo d-lg-none">
          <header class="form-header">
            <h1 class="form-title">Bienvenido</h1>
            <p class="form-subtitle">Ingresa tus credenciales para acceder al sistema</p>
          </header>

          <form role="form" class="login-form" @submit.prevent="handleLogin()">
            <div class="field-group">
              <label for="login-email" class="field-label">Correo electrónico</label>
              <argon-input
                id="login-email"
                v-model="user.email"
                type="email"
                class="login-input"
                placeholder="nombre@empresa.com"
                name="email"
                size="lg"
                icon="ni ni-email-83"
                icon-dir="left"
                :value="user.email"
              />
              <validation-error :errors="apiValidationErrors.email" />
            </div>

            <div class="field-group">
              <label for="login-password" class="field-label">Contraseña</label>
              <argon-input
                id="login-password"
                v-model="user.password"
                type="password"
                class="login-input"
                placeholder="••••••••"
                name="password"
                size="lg"
                icon="ni ni-lock-circle-open"
                icon-dir="left"
                :value="user.password"
              />
            </div>

            <div class="form-options">
              <argon-switch id="rememberMe" input-class="login-switch">Recuérdame</argon-switch>
              <router-link
                :to="{ name: 'Forgot Password' }"
                class="forgot-link"
              >¿Olvidaste tu contraseña?</router-link>
            </div>

            <argon-button
              type="submit"
              class="btn-login"
              color="primary"
              fullWidth
              size="lg"
            >Iniciar sesión</argon-button>
          </form>

          <p class="form-footer">© {{ currentYear }} MI STOCK · Controla, gestiona, crece.</p>
        </div>
      </section>
    </div>
  </main>
</template>

<script>
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonSwitch from "@/components/ArgonSwitch.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import formMixin from "../../mixins/form-mixin.js"
import ValidationError from "../../components/ValidationError.vue";
import showSwal from "../../mixins/showSwal.js";
import Swal from 'sweetalert2';

const body = document.getElementsByTagName("body")[0];

export default {
  name: "Login",
  components: {
    ArgonInput,
    ArgonSwitch,
    ArgonButton,
    ValidationError
  },
  mixins: [formMixin, showSwal],
  data() {
    return {
      user: {
        email: '',
        password: ''
      },
      currentImage: 0,
      carouselInterval: null,
      currentYear: new Date().getFullYear(),
      carouselImages: [
        {
          src: '/assets/fashion-image-1.png',
          alt: 'Gestión de inventario',
          caption: 'Administra tu inventario con precisión y en tiempo real.'
        },
        {
          src: '/assets/fashion-image-2.png',
          alt: 'Control de operaciones',
          caption: 'Optimiza procesos y toma mejores decisiones.'
        },
        {
          src: '/assets/fashion-image-3.png',
          alt: 'Crecimiento del negocio',
          caption: 'Haz crecer tu negocio con herramientas inteligentes.'
        },
      ]
    }
  },
  created() {
    this.$store.state.hideConfigButton = true;
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = false;
    this.$store.state.showFooter = false;
    body.classList.remove("bg-gray-100");
  },
  beforeUnmount() {
    if (this.carouselInterval) {
      clearInterval(this.carouselInterval);
    }
    this.$store.state.hideConfigButton = false;
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    body.classList.add("bg-gray-100");
  },
  mounted() {
    this.carouselInterval = setInterval(() => {
      this.currentImage = (this.currentImage + 1) % this.carouselImages.length;
    }, 6000);
  },
  methods: {
    async handleLogin() {
      try {
        this.resetApiValidation();
        await this.$store.dispatch("auth/login", this.user);

        const userStr = localStorage.getItem('user');
        if (!userStr) {
          throw new Error('Usuario no encontrado después del login');
        }

        const user = JSON.parse(userStr);

        if (user && user.role === '3') {
          this.$router.push({ name: "Operador Dashboard" });
        } else {
          this.$router.push({ name: "Dashboard" });
        }
      }
      catch (error) {
        await Swal.fire({
          icon: 'error',
          title: 'Error de credenciales',
          text: error.response?.data?.message || 'Credenciales no combinan. Intenta de nuevo.',
        });
        if (error.response?.data?.errors) {
          this.setApiValidation(error.response.data.errors);
        }
      }
    },
  }
};
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  background: #f8fafc;
}

.login-shell {
  display: flex;
  min-height: 100vh;
}

/* ── Panel marca ── */
.login-brand-panel {
  position: relative;
  display: none;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: linear-gradient(160deg, #1a2d4a 0%, #0f1c33 45%, #16243f 100%);
  padding: 3rem 2.5rem;
}

.brand-glow {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
  filter: blur(80px);
}

.brand-glow--1 {
  width: 420px;
  height: 420px;
  top: -80px;
  right: -60px;
  background: rgba(204, 153, 0, 0.12);
}

.brand-glow--2 {
  width: 360px;
  height: 360px;
  bottom: -60px;
  left: -40px;
  background: rgba(59, 130, 246, 0.1);
}

.brand-content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 480px;
  text-align: center;
}

.brand-logo-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.875rem 1.75rem;
  margin-bottom: 2.5rem;
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.18);
}

.brand-logo {
  max-height: 56px;
  width: auto;
  display: block;
}

.carousel-frame {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 320px;
  padding: 1.5rem;
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(12px);
}

.carousel-slide {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.carousel-slide img {
  display: block;
  max-width: 100%;
  max-height: min(42vh, 380px);
  object-fit: contain;
}

.carousel-indicators {
  display: flex;
  gap: 0.5rem;
  margin-top: 0;
}

.carousel-indicators button {
  width: 28px;
  height: 4px;
  border: none;
  border-radius: 2px;
  padding: 0;
  background: rgba(255, 255, 255, 0.2);
  cursor: pointer;
  transition: all 0.3s ease;
}

.carousel-indicators button.active {
  width: 40px;
  background: #e6b800;
}

.brand-tagline {
  margin: 1.5rem 0 1.25rem;
  font-size: 0.9375rem;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.75);
  max-width: 380px;
  min-height: calc(0.9375rem * 1.6 * 2);
}

/* ── Panel formulario ── */
.login-form-panel {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 1.5rem;
  background: #ffffff;
}

.form-wrapper {
  width: 100%;
  max-width: 400px;
}

.form-header {
  margin-bottom: 2rem;
}

.form-title {
  margin: 0 0 0.5rem;
  font-size: 1.75rem;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.02em;
}

.form-subtitle {
  margin: 0;
  font-size: 0.9375rem;
  color: #64748b;
  line-height: 1.5;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.field-group {
  margin-bottom: 1.125rem;
}

.field-label {
  display: block;
  margin-bottom: 0.5rem;
  font-size: 0.8125rem;
  font-weight: 600;
  color: #334155;
  letter-spacing: 0.01em;
}

.form-options {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin: 0.5rem 0 1.75rem;
}

.forgot-link {
  font-size: 0.8125rem;
  font-weight: 600;
  color: #1a2d4a;
  text-decoration: none;
  transition: color 0.2s ease;
}

.forgot-link:hover {
  color: #c99200;
}

.btn-login {
  background: #1a2d4a !important;
  border: none !important;
  color: #ffffff !important;
  font-weight: 600 !important;
  letter-spacing: 0.02em;
  border-radius: 10px !important;
  padding: 0.75rem 1.5rem !important;
  transition: background 0.2s ease, transform 0.15s ease, box-shadow 0.2s ease !important;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08) !important;
}

.btn-login:hover {
  background: #243d5e !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.15) !important;
}

.form-footer {
  margin: 2.5rem 0 0;
  text-align: center;
  font-size: 0.75rem;
  color: #94a3b8;
}

/* Inputs */
:deep(.login-input .input-group) {
  align-items: stretch;
}

:deep(.login-input .form-control) {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 0.75rem 1rem;
  font-size: 0.9375rem;
  color: #0f172a;
  background: #f8fafc;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
  min-height: 48px;
}

:deep(.login-input .form-control::placeholder) {
  color: #94a3b8;
}

:deep(.login-input .form-control:focus) {
  border-color: #1a2d4a;
  background: #ffffff;
  box-shadow: 0 0 0 3px rgba(26, 45, 74, 0.1);
}

:deep(.login-input .input-group-text) {
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #64748b;
  padding: 0 0.875rem;
  display: flex;
  align-items: center;
  transition: border-color 0.2s ease, background 0.2s ease;
}

:deep(.login-input .input-group-text i) {
  font-size: 0.875rem;
}

:deep(.login-input .input-group-text.cursor-pointer) {
  cursor: pointer;
}

:deep(.login-input .input-group-text.cursor-pointer:hover) {
  color: #1a2d4a;
}

:deep(.login-input .input-group-text:first-child) {
  border-right: none;
  border-radius: 10px 0 0 10px;
}

:deep(.login-input .input-group .form-control:not(:first-child)) {
  border-left: none;
  border-radius: 0;
}

:deep(.login-input .input-group-text:last-child:not(:first-child)) {
  border-left: none;
  border-radius: 0 10px 10px 0;
}

:deep(.login-input .input-group .form-control:last-child) {
  border-right: none;
  border-radius: 0 10px 10px 0;
}

:deep(.login-input .input-group .form-control:first-child:last-child) {
  border-right: 1px solid #e2e8f0;
  border-radius: 10px;
}

:deep(.login-input .input-group .form-control:not(:first-child):not(:last-child)) {
  border-left: none;
  border-right: none;
  border-radius: 0;
}

:deep(.login-input .input-group:focus-within .input-group-text) {
  border-color: #1a2d4a;
  background: #ffffff;
}

:deep(.login-input .input-group:focus-within .form-control) {
  border-color: #1a2d4a;
  background: #ffffff;
  box-shadow: none;
}

:deep(.login-input .input-group:focus-within) {
  box-shadow: 0 0 0 3px rgba(26, 45, 74, 0.1);
  border-radius: 10px;
}

:deep(.form-check.form-switch) {
  margin: 0;
  padding-left: 0;
  display: flex;
  align-items: center;
  gap: 0.625rem;
}

:deep(.form-check.form-switch .form-check-input) {
  width: 2.25rem;
  height: 1.25rem;
  margin: 0;
  cursor: pointer;
  border: none;
  background-color: #cbd5e1;
  transition: background-color 0.2s ease;
}

:deep(.form-check.form-switch .form-check-input:checked) {
  background-color: #1a2d4a;
}

:deep(.form-check.form-switch .form-check-label) {
  font-size: 0.8125rem;
  color: #475569;
  cursor: pointer;
  user-select: none;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

@media (min-width: 992px) {
  .login-brand-panel {
    display: flex;
    max-width: 52%;
  }

  .login-form-panel {
    max-width: 48%;
    border-left: 1px solid #e2e8f0;
  }
}

@media (max-width: 991.98px) {
  .login-page {
    background: linear-gradient(180deg, #1a2d4a 0%, #0f1c33 120px, #f8fafc 120px);
  }

  .login-form-panel {
    align-items: flex-start;
    padding-top: 2.5rem;
  }

  .form-wrapper {
    background: #ffffff;
    border-radius: 20px;
    padding: 2rem 1.5rem;
    box-shadow: 0 4px 24px rgba(15, 23, 42, 0.08);
  }

  .form-header {
    text-align: center;
  }

  .mobile-logo {
    display: block;
    max-height: 56px;
    margin: 0 auto 1.5rem;
  }
}
</style>
